<div class="min-h-screen  dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300 transition-colors relative"
    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

    <!-- Drag Overlay -->
    <div *ngIf="isDraggingOver"
        class="absolute inset-0 z-[100] bg-amber-500/10 backdrop-blur-sm border-4 border-dashed border-amber-500 rounded-3xl flex items-center justify-center animate-fade-in pointer-events-none m-4 md:m-8">
        <div
            class="bg-white dark:bg-slate-800 p-8 rounded-3xl shadow-2xl flex flex-col items-center gap-4 animate-bounce">
            <div
                class="w-20 h-20 bg-amber-100 dark:bg-amber-500/20 rounded-full flex items-center justify-center text-amber-500">
                <span class="material-icons-outlined text-5xl">travel_explore</span>
            </div>
            <h2 class="text-2xl font-black text-slate-800 dark:text-white">วางข้อมูลที่นี่เพื่อค้นหา</h2>
            <p class="text-slate-500 font-bold">ระบบจะนำเบอร์โทรศัพท์หรือชื่อมาค้นหาให้อัตโนมัติ</p>
        </div>
    </div>

    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">สมาชิก Line OA</h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ค้นหาสมาชิก แล้วคลิกรายการเพื่อดูโปรไฟล์ รถ และบัตรจอด</p>
        </div>
        <div class="flex flex-col sm:flex-row items-center gap-3">
            <button (click)="toggleDashboard()"
                class="hidden sm:flex px-4 py-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 items-center gap-2"
                [title]="showDashboard ? 'ซ่อนกราฟ' : 'แสดงกราฟ'">
                <span class="material-icons">{{ showDashboard ? 'visibility_off' : 'visibility' }}</span>
                <span class="text-sm font-bold">{{ showDashboard ? 'ซ่อนกราฟ' : 'แสดงกราฟ' }}</span>
            </button>

            <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
                <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
                <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
            </div>
            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center"
                title="รีเฟรช">
                <span class="material-icons">refresh</span>
            </button>
        </div>
    </div>

    <!-- Collapsible Dashboard Section -->
    <div class="overflow-hidden transition-all duration-500 ease-in-out"
        [style.max-height]="showDashboard ? '1000px' : '0'" [style.opacity]="showDashboard ? '1' : '0'"
        [style.margin-bottom]="showDashboard ? '2rem' : '0'">

        <!-- Stats Cards -->
        <div *ngIf="dashboardStats.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div *ngFor="let stat of dashboardStats; let i = index"
                class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
                [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">

                <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-[0.15] transition-transform group-hover:scale-110"
                    [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

                <div class="relative z-10 flex justify-between items-start mb-4">
                    <div class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
                        [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
                        <span class="material-icons text-2xl">{{ stat.icon }}</span>
                    </div>
                    <!-- Change indicator removed for simplicity as requested -->
                </div>

                <div class="relative z-10">
                    <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">{{
                        stat.title }}</h4>
                    <div class="text-3xl font-black text-slate-800 dark:text-slate-100">{{ stat.value }}</div>
                </div>
            </div>
        </div>
        <!-- 
        <div class="mb-4">
            <h1 class="text-2xl font-bold text-purple-900 dark:text-purple-100 tracking-tight">ภาพรวมสถิติ
            </h1>
        </div> -->

        <!-- Circular Progress (Member Ratio) - Full Width -->
        <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-4xl shadow-lg shadow-gray-100/50 dark:shadow-slate-700 border border-gray-100/50 dark:border-slate-700 p-8 mb-8 transition-all duration-300"
            style="animation-delay: 0.24s;">
            <div class="flex justify-between items-center" [class.mb-6]="showRatioChart">
                <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100">สัดส่วนสมาชิก (7 วันล่าสุด)</h3>
                <button (click)="showRatioChart = !showRatioChart"
                    class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 hover:text-amber-500 transition-colors">
                    <span class="material-icons">{{ showRatioChart ? 'expand_less' : 'expand_more' }}</span>
                </button>
            </div>

            <!-- Collapsible Body -->
            <div *ngIf="showRatioChart"
                class="animate-fade-in flex flex-col sm:flex-row items-center justify-center gap-8 mt-2">
                <!-- Circular Progress SVG -->
                <div class="relative w-32 h-32 flex-shrink-0">
                    <!-- Background Circle -->
                    <svg viewBox="0 0 36 36" class="w-full h-full transform -rotate-90">
                        <path class="text-slate-100 dark:text-slate-700" stroke-dasharray="100, 100"
                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                            fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" />
                        <!-- Foreground Circle (NEW) -->
                        <path class="text-amber-500 transition-all duration-1000 ease-out"
                            [attr.stroke-dasharray]="newPercent + ', 100'"
                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                            fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" />
                    </svg>
                    <!-- Center Text -->
                    <div class="absolute inset-0 flex flex-col items-center justify-center">
                        <span
                            class="text-3xl font-black text-slate-800 dark:text-slate-100 leading-none">{{newPercent}}%</span>
                        <span class="text-[10px] font-bold text-amber-500 uppercase tracking-widest mt-1">NEW</span>
                    </div>
                </div>
                <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-3">
                        <div class="w-4 h-4 rounded-full bg-amber-500 shadow-sm shadow-amber-500/40"></div>
                        <div class="flex flex-col">
                            <span
                                class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">สมาชิกใหม่</span>
                            <span
                                class="text-lg font-black text-slate-700 dark:text-slate-200 leading-tight">{{newPercent}}%</span>
                        </div>
                    </div>
                    <div class="flex items-center gap-3">
                        <div
                            class="w-4 h-4 rounded-full bg-slate-100 dark:bg-slate-700 shadow-inner border border-slate-200 dark:border-slate-600">
                        </div>
                        <div class="flex flex-col">
                            <span
                                class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">สมาชิกเดิม</span>
                            <span
                                class="text-lg font-black text-slate-700 dark:text-slate-200 leading-tight">{{oldPercent}}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
            <!-- Chart Section -->
            <div class="animate-fade-in lg:col-span-2 bg-white dark:bg-slate-800 rounded-4xl shadow-lg shadow-gray-100/50 dark:shadow-slate-700 border border-gray-100/50 dark:border-slate-700 pt-8 pb-12 px-12 relative overflow-visible z-0"
                style="animation-delay: 0.25s;">
                <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                    <div>
                        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100">
                            แนวโน้มการลงทะเบียน
                            <span
                                class="text-sm font-medium text-slate-500 dark:text-slate-300 ml-2 bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded-full">
                                {{ chartTotalCount }} รายการ
                            </span>
                        </h3>
                        <div class="flex items-center gap-4 text-xs font-medium mt-1">
                            <span class="flex items-center gap-1 "><span
                                    class="w-2 h-2 rounded-full bg-amber-400"></span>
                                <span class="text-slate-600 dark:text-slate-300">{{ chartMode === 'daily' ? 'รายวัน' :
                                    'รายเดือน' }}</span>
                                <span class="text-slate-400 dark:text-slate-500">
                                    @if(chartMode === 'daily' && dailySubMode === 'default') {
                                    ( 7 วันย้อนหลัง )
                                    }
                                    @if(chartMode === 'daily' && dailySubMode === 'custom') {
                                    ( สูงสุด 10 วัน)
                                    }
                                    @if(chartMode === 'monthly') {
                                    ( {{ selectedMonthStart | date: 'MM/yyyy' }} - {{ selectedMonthEnd | date: 'MM/yyyy'
                                    }}
                                    )
                                    } </span>
                            </span>
                        </div>
                    </div>

                    <!-- Chart Controls -->
                    <div class="flex flex-col items-end gap-2">

                        <!-- Row 1: Inputs & Sub-Modes -->
                        <div class="flex items-center gap-2 min-h-[34px]">
                            <!-- Daily Controls -->
                            <div *ngIf="chartMode === 'daily'" class="flex items-center gap-2">
                                <div
                                    class="flex bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 gap-1">
                                    <button (click)="setDailySubMode('default')"
                                        class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                                        [ngClass]="dailySubMode === 'default' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'">
                                        ทั้งหมด
                                    </button>
                                    <button (click)="setDailySubMode('custom')"
                                        class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                                        [ngClass]="dailySubMode === 'custom' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'">
                                        กำหนดเอง
                                    </button>
                                </div>

                                <div *ngIf="dailySubMode === 'custom'"
                                    class="flex items-center bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1">
                                    <input type="date" [(ngModel)]="customStartDate" (change)="onCustomDateChange()"
                                        [max]="customEndDate"
                                        class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-[105px] dark:[color-scheme:dark]">
                                    <span class="mx-1 text-slate-300 dark:text-slate-600">-</span>
                                    <input type="date" [(ngModel)]="customEndDate" (change)="onCustomDateChange()"
                                        [min]="customStartDate" [max]="maxCustomDate"
                                        class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-[105px] dark:[color-scheme:dark]">

                                    <button (click)="resetCustomDate()"
                                        class="ml-2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-colors cursor-pointer"
                                        title="รีเซ็ต">
                                        <span class="material-icons text-[16px]">refresh</span>
                                    </button>
                                </div>
                            </div>

                            <!-- Monthly Inputs -->
                            <div *ngIf="chartMode === 'monthly'"
                                class="flex items-center gap-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1">
                                <input type="month" [(ngModel)]="selectedMonthStart" (change)="onChartMonthChange()"
                                    class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px] dark:[color-scheme:dark]">
                                <span class="text-slate-300 dark:text-slate-600 mx-1">-</span>
                                <input type="month" [(ngModel)]="selectedMonthEnd" (change)="onChartMonthChange()"
                                    [min]="selectedMonthStart" [max]="maxMonthEnd"
                                    class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px] dark:[color-scheme:dark]">
                            </div>
                        </div>

                        <!-- Row 2: Toggles -->
                        <div class="flex items-center gap-2">
                            <!-- Chart Type -->
                            <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-lg">
                                <button (click)="setChartType('line')"
                                    [class]="chartType === 'line' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="p-1 px-2 rounded-md transition-all">
                                    <span class="material-icons text-sm">show_chart</span>
                                </button>
                                <button (click)="setChartType('bar')"
                                    [class]="chartType === 'bar' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="p-1 px-2 rounded-md transition-all">
                                    <span class="material-icons text-sm">bar_chart</span>
                                </button>
                            </div>

                            <!-- Mode Toggle -->
                            <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-lg">
                                <button (click)="setChartMode('daily')"
                                    [class]="chartMode === 'daily' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายวัน</button>
                                <button (click)="setChartMode('monthly')"
                                    [class]="chartMode === 'monthly' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายเดือน</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="relative h-64 w-full pl-6">
                    <!-- Y-Axis Labels -->
                    <div
                        class="absolute inset-y-0 left-[-30px] bottom-0 w-8 flex flex-col justify-between text-[9px] text-slate-400 font-medium pointer-events-none py-2 items-end pr-1">
                        <span>{{ yAxisLabels[4] }}</span>
                        <span>{{ yAxisLabels[3] }}</span>
                        <span>{{ yAxisLabels[2] }}</span>
                        <span>{{ yAxisLabels[1] }}</span>
                        <span class="translate-y-1">{{ yAxisLabels[0] }}</span>
                    </div>

                    <svg viewBox="0 0 100 100" class="w-full h-full overflow-visible" preserveAspectRatio="none">
                        <defs>
                            <linearGradient id="gradientArea" x1="0" x2="0" y1="0" y2="1">
                                <stop offset="0%" stop-color="#fbbf24" stop-opacity="0.4" />
                                <stop offset="100%" stop-color="#fbbf24" stop-opacity="0" />
                            </linearGradient>
                        </defs>

                        <!-- Grid Lines (Background) -->
                        <g class="text-slate-200 dark:text-slate-700 pointer-events-none">
                            <line x1="0" y1="100" x2="100" y2="100" stroke="currentColor" stroke-width="0.5" />
                            <line x1="0" y1="75" x2="100" y2="75" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="25" x2="100" y2="25" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="0" x2="100" y2="0" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                        </g>

                        <!-- Line Chart -->
                        <g *ngIf="chartType === 'line'">
                            <polygon [attr.points]="currentMonthAreaPoints" fill="url(#gradientArea)"
                                class="opacity-50 transition-all duration-500" />
                            <polyline [attr.points]="currentMonthPoints" fill="none" stroke="#fbbf24" stroke-width="0.5"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="drop-shadow-sm transition-all duration-500" />
                            <circle *ngFor="let point of currentMonthDots" [attr.cx]="point.x" [attr.cy]="point.y"
                                r="1.5" fill="#fff" stroke="#fbbf24" stroke-width="1"
                                class="opacity-0 hover:opacity-100 transition-opacity cursor-pointer">
                                <title>{{ point.label }}: {{ point.value }}</title>
                            </circle>
                        </g>

                        <!-- Bar Chart - Matched RegisterParking -->
                        <g *ngIf="chartType === 'bar'">
                            <rect *ngFor="let point of currentMonthDots" [attr.x]="point.x - 2" [attr.y]="point.y"
                                width="4" [attr.height]="100 - point.y" [attr.fill]="point.color"
                                class="hover:opacity-80 hover:fill-yellow-500 border-2 border-white dark:border-slate-800 transition-all duration-300 cursor-pointer rx-[1px]">
                                <title>{{ point.label }}: {{ point.value }}</title>
                            </rect>
                        </g>
                    </svg>

                    <!-- Dynamic Labels (X-Axis) - Matched RegisterParking -->
                    <div class="absolute bottom-0 left-0 right-0 translate-y-8 h-8 pointer-events-none">
                        <ng-container *ngFor="let dot of currentMonthDots; let i = index">
                            <div *ngIf="(currentMonthDots.length <= 15) || (i % 5 === 0) || i === 0 || i === currentMonthDots.length - 1"
                                class="absolute top-0 flex flex-col items-center whitespace-nowrap"
                                [style.left.%]="dot.x" style="transform: translateX(-50%);">
                                <span class="text-[10px] text-slate-400 font-medium">{{ dot.label }}</span>
                                <span *ngIf="dot.subLabel" class="text-[9px] text-slate-400">{{ dot.subLabel }}</span>
                            </div>
                        </ng-container>
                    </div>


                </div>
            </div>

            <!-- Right Column -->
            <div class="lg:col-span-1 flex flex-col gap-8">
                <!-- Recent Activity -->
                <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-4xl shadow-lg shadow-gray-100/50 dark:shadow-slate-700 border border-gray-100/50 dark:border-slate-700 p-8"
                    style="animation-delay: 0.3s;">
                    <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 mb-6">สมาชิกใหม่ล่าสุด</h3>
                    <div class="relative">
                        <div class="absolute left-5 top-4 bottom-4 w-0.5 bg-slate-100 dark:bg-slate-700"></div>
                        <div class="space-y-6 relative">
                            <div *ngFor="let item of recentActivity" class="flex items-start gap-4 group">
                                <div
                                    class="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-amber-600 dark:text-amber-400 text-sm font-bold shadow-sm ring-4 ring-white dark:ring-slate-800 z-10 bg-amber-100 dark:bg-amber-500/20 transition-transform group-hover:scale-110">
                                    {{ item.initial }}
                                </div>
                                <div class="flex-1 pt-1">
                                    <div class="flex justify-between items-start">
                                        <h5
                                            class="text-sm font-bold text-slate-800 dark:text-slate-200 group-hover:text-amber-500 transition-colors">
                                            {{ item.name }}</h5>
                                        <span
                                            class="text-[10px] font-semibold text-slate-400 dark:text-slate-400 bg-slate-50 dark:bg-slate-700 px-2 py-0.5 rounded-full border border-slate-100 dark:border-slate-600 whitespace-nowrap">{{
                                            item.timeAgo }}</span>
                                    </div>
                                    <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{{ item.info }}</p>
                                </div>
                            </div>
                            <div *ngIf="recentActivity.length === 0"
                                class="text-center text-slate-400 dark:text-slate-500 py-10">
                                <span class="material-icons text-3xl mb-2 opacity-50">history</span>
                                <p class="text-sm">ไม่มีกิจกรรมล่าสุด</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <!-- End Collapsible Dashboard Section -->

    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-lg shadow-gray-100/50 border border-gray-100/50 dark:border-slate-700 overflow-hidden transition-colors"
        style="animation-delay: 0.35s;">
        <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col gap-4 relative z-30">
            <div class="flex items-center justify-between">
                <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                    <span class="material-icons text-amber-500">list_alt</span>
                    รายชื่อสมาชิก
                </h3>
                <span class="px-3 py-1 rounded-full bg-slate-100 dark:bg-slate-700 text-xs font-bold text-slate-500 dark:text-slate-300">
                    {{ totalItems | number }} คน
                </span>
            </div>

            <!-- Filters Row (always visible) -->
            <div class="flex flex-col lg:flex-row lg:items-center gap-3">
                <!-- Language Filter (Custom Dropdown) -->
                <div class="relative w-full lg:w-[150px] shrink-0 z-30 lg:order-2">
                    <button (click)="toggleLangDropdown()"
                        class="w-full h-[46px] pl-3 pr-4 bg-slate-50 dark:bg-slate-900 rounded-xl text-sm font-bold border border-transparent dark:border-slate-700 transition-all flex items-center justify-between group hover:bg-white dark:hover:bg-slate-800 hover:shadow-sm hover:border-slate-200 dark:hover:border-slate-600"
                        [ngClass]="{'bg-white dark:bg-slate-800 ring-2 ring-amber-200': isLangDropdownOpen}">
                        <div class="flex items-center gap-2 text-slate-600 dark:text-slate-300">
                            <span class="material-icons  text-slate-400" style="font-size: 18px;"
                                *ngIf="languageFilter === 'all'">language</span>
                            <img *ngIf="languageFilter === 'th'" src="assets/images/flag-th.png" alt="TH"
                                class="w-5 h-5 rounded-full object-cover"
                                onError="this.style.display='none'; this.nextElementSibling.style.display='inline-block'">
                            <span *ngIf="languageFilter === 'th'"
                                class="material-icons text-lg text-red-500 hidden">flag</span>
                            <img *ngIf="languageFilter === 'en'" src="assets/images/flag-en.png" alt="EN"
                                class="w-5 h-5 rounded-full object-cover"
                                onError="this.style.display='none'; this.nextElementSibling.style.display='inline-block'">
                            <span *ngIf="languageFilter === 'en'"
                                class="material-icons text-lg text-blue-500 hidden">flag</span>

                            <span>{{ languageFilter === 'all' ? 'ทุกภาษา' : (languageFilter | uppercase) }}</span>
                        </div>
                        <span class="material-icons text-sm text-slate-400 transition-transform duration-200"
                            [ngClass]="{'rotate-180': isLangDropdownOpen}">expand_more</span>
                    </button>

                    <!-- Lang Dropdown Menu -->
                    <div *ngIf="isLangDropdownOpen"
                        class="absolute top-full mt-2 left-0 w-full bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden animation-fade-in-up">
                        <button (click)="selectLanguage('all')"
                            class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center gap-2">
                            <span class="material-icons text-slate-400" style="font-size: 16px;">language</span>
                            ทุกภาษา
                        </button>
                        <button (click)="selectLanguage('th')"
                            class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center gap-2">
                            <span>🇹🇭</span> TH
                        </button>
                        <button (click)="selectLanguage('en')"
                            class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center gap-2">
                            <span>🇬🇧</span> EN
                        </button>
                    </div>
                    <!-- Backdrop -->
                    <div *ngIf="isLangDropdownOpen" class="fixed inset-0 z-40" (click)="toggleLangDropdown()"></div>
                </div>

                <!-- Search Type & Input Group + Search Button -->
                <div class="flex items-center gap-2 w-full flex-1 lg:order-1">
                    <div
                        class="flex items-center h-[46px] bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-visible flex-1 min-w-0 relative z-30">

                        <!-- Custom Search Type Dropdown -->
                        <div class="relative h-full min-w-[150px] shrink-0 border-r border-slate-200 dark:border-slate-700">
                            <button (click)="toggleSearchTypeDropdown()"
                                class="w-full h-full pl-4 pr-3 text-sm font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between hover:text-amber-600 dark:hover:text-amber-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-l-xl transition-all focus:outline-none">
                                <span>{{ currentSearchTypeLabel }}</span>
                                <span class="material-icons text-sm text-slate-400 transition-transform duration-200"
                                    [ngClass]="{'rotate-180': isSearchTypeDropdownOpen}">expand_more</span>
                            </button>

                            <!-- Type Dropdown Menu -->
                            <button *ngIf="isSearchTypeDropdownOpen" class="fixed inset-0 cursor-default z-40"
                                (click)="toggleSearchTypeDropdown()"></button>
                            <div *ngIf="isSearchTypeDropdownOpen"
                                class="absolute top-full mt-2 left-0 w-[180px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden animation-fade-in-up">
                                <button (click)="selectSearchType('name')"
                                    class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center gap-2">
                                    <span class="material-icons text-slate-400" style="font-size: 18px;">person</span>
                                    ชื่อ-นามสกุล
                                </button>
                                <button (click)="selectSearchType('lineName')"
                                    class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center gap-2">
                                    <span class="material-icons text-slate-400" style="font-size: 18px;">chat</span>
                                    ชื่อ Line
                                </button>
                                <button (click)="selectSearchType('phone')"
                                    class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center gap-2">
                                    <span class="material-icons text-slate-400" style="font-size: 18px;">phone</span>
                                    เบอร์โทรศัพท์
                                </button>
                            </div>
                        </div>

                        <div class="relative flex-1 h-full min-w-0 flex items-center">
                            <span
                                class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-xl">search</span>
                            <input type="text"
                                [placeholder]="searchType === 'name' ? 'พิมพ์ชื่อ-นามสกุล แล้วกด Enter' : (searchType === 'lineName' ? 'พิมพ์ชื่อ Line แล้วกด Enter' : 'พิมพ์เบอร์โทรศัพท์ แล้วกด Enter')"
                                [(ngModel)]="searchText" (keyup.enter)="onClickSearch()" (keyup.escape)="clearSearch()"
                                class="w-full h-full pl-10 pr-10 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-500 rounded-r-xl">
                            <button *ngIf="searchText" type="button" (click)="clearSearch()"
                                class="absolute right-2 w-7 h-7 flex items-center justify-center rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 dark:hover:text-slate-200 dark:hover:bg-slate-700 transition-colors"
                                title="ล้างคำค้นหา">
                                <span class="material-icons text-[18px]">close</span>
                            </button>
                        </div>
                    </div>

                    <button (click)="onClickSearch()"
                        class="shrink-0 px-5 h-[46px] bg-amber-400 hover:bg-amber-500 text-white font-bold text-sm rounded-xl transition-all shadow-sm active:scale-95 flex items-center gap-1.5 cursor-pointer">
                        <span class="material-icons text-[18px]">search</span>
                        ค้นหา
                    </button>
                </div>
            </div>
        </div>

        <div class="overflow-x-auto h-[600px] relative custom-scrollbar">
            <table class="w-full text-left border-collapse">
                <thead
                    class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm dark:shadow-slate-900/50">
                    <tr>
                        <th (click)="sortData('id')"
                            class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group">
                            <div class="flex items-center gap-1"> # <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400"
                                    [class.opacity-100]="sortColumn === 'id'">{{ sortColumn === 'id' &&
                                    sortDirection
                                    === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('name')"
                            class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group">
                            <div class="flex items-center gap-1"> ชื่อ - นามสกุล <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400"
                                    [class.opacity-100]="sortColumn === 'name'">{{ sortColumn === 'name' &&
                                    sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('fullName')"
                            class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group">
                            <div class="flex items-center gap-1"> ชื่อ Line <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400"
                                    [class.opacity-100]="sortColumn === 'fullName'">{{ sortColumn === 'fullName' &&
                                    sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                            เบอร์โทรศัพท์</th>
                        <th
                            class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center">
                            ภาษา
                        </th>
                        <th (click)="sortData('registerDate')"
                            class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors group text-right">
                            <div class="flex items-center justify-end gap-1"> วันที่สมัคร <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-400"
                                    [class.opacity-100]="sortColumn === 'registerDate'">{{ sortColumn ===
                                    'registerDate'
                                    && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th
                            class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-center">
                            จัดการ
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
                    <tr *ngFor="let m of members; let i = index" (click)="openModal(m)"
                        class="animate-table-row group cursor-pointer hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200"
                        [ngStyle]="{'animation-delay': (i * 0.03) + 's'}">
                        <td
                            class="p-5 text-sm font-bold text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors">
                            #{{ m.id }}</td>
                        <td class="p-5">
                            <div class="flex items-center gap-3">
                                <div
                                    class="w-9 h-9 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center overflow-hidden shrink-0 border border-slate-200 dark:border-slate-600">
                                    <img *ngIf="m.pictureUrl && !isPictureBroken(m.id)"
                                        [src]="m.pictureUrl" [alt]="m.name || 'LINE'"
                                        (error)="onPictureError(m.id)"
                                        class="w-full h-full object-cover" />
                                    <span *ngIf="!m.pictureUrl || isPictureBroken(m.id)"
                                        class="material-icons text-[18px] text-slate-400 dark:text-slate-500"
                                        title="ไม่พบรูปโปรไฟล์">broken_image</span>
                                </div>
                                <div class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ m.name }}</div>
                            </div>
                        </td>
                        <td class="p-5">
                            <span
                                class="px-2.5 py-1 rounded-full text-xs font-bold bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 border border-green-100 dark:border-green-800">{{
                                m.fullName }}</span>
                        </td>
                        <td class="p-5 text-sm text-slate-600 dark:text-slate-300 font-medium">{{ m.phone }}</td>
                        <td class="p-5 text-center">
                            <span
                                class="px-2 py-1 bg-slate-100 dark:bg-slate-700 rounded text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">{{
                                m.language }}</span>
                        </td>
                        <td class="p-5 text-sm text-slate-500 dark:text-slate-400 text-right font-medium">{{
                            m.createDate
                            | date:'d MMM yyyy' }}</td>
                        <td class="p-5 text-center">
                            <button (click)="$event.stopPropagation(); openModal(m)"
                                class="w-8 h-8 inline-flex items-center justify-center rounded-lg text-slate-400 dark:text-slate-500 hover:text-white dark:hover:text-white hover:bg-amber-400 hover:shadow-lg hover:shadow-amber-200 dark:hover:shadow-amber-900/50 transition-all duration-200 transform hover:scale-105"
                                title="แก้ไข">
                                <span class="material-icons text-[18px]">edit</span>
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="members.length === 0 && !isLoading">
                        <td colspan="7" class="py-20 text-center">
                            <div class="flex flex-col items-center justify-center">
                                <div
                                    class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3">
                                    <span
                                        class="material-icons text-3xl text-slate-300 dark:text-slate-600">search_off</span>
                                </div>
                                <h3 class="text-slate-800 dark:text-slate-300 font-bold">ไม่พบข้อมูล</h3>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div
            class="p-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
            <div class="flex items-center gap-3 text-sm text-slate-500 dark:text-slate-400 font-medium">
                <span>แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ totalItems | number }} รายการ</span>
                <select [(ngModel)]="pageSize" (change)="onPageSizeChange()"
                    class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg py-1 px-2 focus:ring-amber-200 dark:text-slate-300">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
                </select>
            </div>
            <div class="flex items-center gap-2">
                <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
                    class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-30 text-slate-600 dark:text-slate-300">
                    <span class="material-icons text-sm">chevron_left</span>
                </button>
                <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                    class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
                    [ngClass]="page === currentPage ? 'bg-amber-400 text-white shadow-lg shadow-amber-200 dark:shadow-amber-900/50' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700'">
                    {{ page }}
                </button>
                <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages"
                    class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 disabled:opacity-30 text-slate-600 dark:text-slate-300">
                    <span class="material-icons text-sm">chevron_right</span>
                </button>
            </div>
        </div>
    </div>
</div>

<app-modal-line-oa-member *ngIf="isModalOpen" [member]="selectedMember"
    (close)="closeModal()"></app-modal-line-oa-member>